import React from 'react';
import FiltersGroups from 'modules/shared/components/filters/components/filters-groups';
import Link from 'atomic/link';
import Icon from 'atomic/icon';
import { FiltersGroup } from 'modules/shared/components/filters/interfaces/filters-group.interface';
import { FiltersActions } from 'modules/producers/reducers/producer-url-params.reducer';
import { useProducerUrlType } from 'modules/producers/hooks/use-producer-url';
import { useCategoryUrlType } from 'modules/categories/interfaces/use-category-url.type';
import { useSeo } from 'hooks/use-seo';

import './filters-desktop.scss';

interface FiltersDesktopProps {
    getUrl: useCategoryUrlType | useProducerUrlType;
    filters: {
        groups: FiltersGroup[];
    };
    showPriceFilter?: boolean;
    filtersActions: typeof FiltersActions;
}

const FiltersDesktop: React.FC<FiltersDesktopProps> = ({ getUrl, filters, showPriceFilter, filtersActions }) => {
    const seo = useSeo();

    return (
        <div className="filters-desktop">
            <FiltersGroups
                filters={filters}
                getUrl={getUrl}
                showPriceFilter={showPriceFilter}
                filtersActions={filtersActions}
            />
            <div className="filters-desktop__action">
                <div className="filters-desktop__action--submit">
                    <Link
                        href={getUrl({ query: {} })}
                        color="primary"
                        type="button"
                        block={true}
                        size="lg"
                        rel={seo.rel}
                    >
                        Filtruj
                    </Link>
                </div>
                <div className="filters-desktop__action--reset">
                    <Link
                        href={getUrl({
                            filters: [],
                            page: 1,
                            price: { min: 0, max: 0 },
                            query: {}
                        })}
                        color="transparent"
                        type="button"
                        block={true}
                        size="lg"
                    >
                        <Icon name="x" size={16} color="primary" />
                        Wyczyść filtry
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default FiltersDesktop;
